module.exports = __webpack_public_path__ + "img/checklist_desk.e6c591db.png";